import { render, staticRenderFns } from "./TopbarItem.vue?vue&type=template&id=5506d85c&scoped=true&lang=pug&"
import script from "./TopbarItem.vue?vue&type=script&lang=js&"
export * from "./TopbarItem.vue?vue&type=script&lang=js&"
import style0 from "./TopbarItem.vue?vue&type=style&index=0&id=5506d85c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5506d85c",
  null
  
)

export default component.exports